import { useEffect, useState } from 'react';
import Home from './pages/Home';
import Student from './pages/Student';

type Route =
  | { kind: 'home' }
  | { kind: 'student'; token: string }
  | { kind: 'unknown' };

function parseRoute(): Route {
  const path = window.location.pathname || '/';
  if (path === '/' || path === '') return { kind: 'home' };
  const m = path.match(/^\/s\/([A-Za-z0-9_-]{8,128})\/?$/);
  if (m) return { kind: 'student', token: m[1] };
  return { kind: 'unknown' };
}

export default function App() {
  const [route, setRoute] = useState<Route>(() => parseRoute());

  useEffect(() => {
    const onPop = () => setRoute(parseRoute());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  if (route.kind === 'student') return <Student token={route.token} />;
  if (route.kind === 'home') return <Home />;
  return <Home unknown />;
}
